<template>
  <div class="login-wrap">
    <div class="login-box">
      <a href="javascript:;" class="close-btn"></a>
      <div class="input-box">
        <input type="text" placeholder="用户名" />
      </div>
      <div class="input-box">
        <input type="password" placeholder="密码" />
      </div>
      <button class="btn">登录</button>
    </div>
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
@imgPath: "../assets/img/";
.login-wrap {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(13, 6, 44, 0.73);
  z-index: 1000;
  overflow: hidden;
  .login-box {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -231px;
    margin-top: -236px;
    width: 462px;
    height: 472px;
    padding: 170px 63px 78px;
    background: #fff;
    border-radius: 16px;
    &:before {
      content: '';
      position: absolute;
      top: 52px;
      left: 131px;
      width: 200px;
      height: 47px;
      background: url('@{imgPath}/logo2.png') no-repeat;
      background-size: contain;
      background-position: center;
    }
    .close-btn {
      position: absolute;
      top: 0;
      right: -48px;
      width: 24px;
      height: 24px;
      background: url('@{imgPath}/close.png') no-repeat;
      background-size: contain;
      background-position: center;
      z-index: 100;
    }
    .input-box {
      position: relative;
      height: 40px;
      margin-bottom: 16px;
      &:after {
        content: '';
        position: absolute;
        display: block;
        left: 0;
        bottom: 0px;
        width: 100%;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        -webkit-transform: scaleY(0.5);
        -ms-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      input {
        width: 100%;
        height: 100%;
        border: none;
        font-size:16px;
        font-weight:500;
        color:rgba(59,59,59,1);
        line-height:22px;
        outline: none;
      }
    }
    .btn {
      display: block;
      margin: 70px auto 0;
      width:170px;
      height:50px;
      background:rgba(82,63,170,1);
      border-radius:30px;
      border: none;
      color: #fff;
      font-size:16px;
      &:hover {
        background: #3e2f84;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// r-login.vue?44c65f04